module.exports = __webpack_public_path__ + "assets/img/service-b0f55603.png";